<template>
  <main-wrapper>
    <div class="calculator-wrapper">
      <el-tabs class="calculator-row" v-model="activeName">
        <el-tab-pane :label="$t('calculator.node')" name="first">
          <div class="header-tip">{{ $t("calculator.choosenodetype") }}</div>
          <node-nav
            :leastNum="leastNum"
            :totalmaxAmount="totalMaxAmount"
          />
        </el-tab-pane>
        <el-tab-pane :label="$t('calculator.user')" name="second">
          <div class="header-tip">{{ $t("calculator.choosenodetypeuser") }}</div>
          <user-nav
            v-if="nodelist[0]"
            :leastNum="leastNum"
            :nodelist="nodelist"
            :totalmaxAmount="totalMaxAmount"
          ></user-nav>
        </el-tab-pane>
      </el-tabs>
      <div class="calculator-row">
        <p class="footer-tip mgb10">
          {{ $t("calculator.typemsg") }}
          <a :href="$t('calculator.url')" target="_blank">{{ $t("calculator.doc") }}</a>
        </p>
        <p class="footer-tip">{{ $t("calculator.disclaima") }}</p>
      </div>
    </div>
  </main-wrapper>
</template>

<script>
import MainWrapper from "common/components/MainWrapper.vue";
import NodeNav from "./components/Node";
import UserNav from "./components/User";
export default {
  name: "calculator",
  components: {
    MainWrapper,
    NodeNav,
    UserNav,
  },
  computed: {
    leastNum() {
      return this.$store.getters.calculationinfo.the_last_consensus_stake || 0;
    },
    totalMaxAmount() {
      return this.totalsupply.ont - this.totalstake.current_total_stakes
    },
    nodelist() {
      return this.$store.getters.NodeList || [];
    },
    offnodelist() {
      return this.$store.getters.offNodeList || [];
    },
    annualList() {
      return this.$store.getters.annualList || [];
    },
    totalstake() {
      return this.$store.getters.totalstakeamount || {};
    },
    totalsupply() {
      return this.$store.getters.totalsupply || {};
    },
  },
  data() {
    return {
      activeName: "first",
    };
  },
  watch: {
    nodelist: function() {
      for (let i = 0; i < this.nodelist.length; i++) {
        for (let j = 0; j < this.offnodelist.length; j++) {
          if (this.nodelist[i].public_key == this.offnodelist[j].public_key) {
            this.nodelist[i].region = this.offnodelist[j].region;
            this.nodelist[i].social_media = this.offnodelist[j].social_media;
            this.nodelist[i].website = this.offnodelist[j].website;
            this.nodelist[i].verification = this.offnodelist[j].verification;
            this.nodelist[i].annual = this.getAnnual(
              this.nodelist[i].public_key
            );
          }
        }
      }
    },
    offnodelist: function() {
      this.getNodeList();
    },
    totalstake: function() {
      this.getTotalSupply();
    },
  },
  mounted() {
    if (!this.$route.params.type) {
      this.$router.push({ name: "calculator", params: { type: "node" } });
    } else {
      if (this.$route.params.type == "node") {
        this.activeName = "first";
      } else {
        this.activeName = "second";
      }
    }
    this.getTotalStake();
    this.getCalculationInfo();
    this.getoffNodeList();
    this.getAnnualList();
  },
  methods: {
    getCalculationInfo() {
      this.$store.dispatch("getCalculationInfo").then();
    },
    getNodeList() {
      this.$store.dispatch("getNodeList").then();
    },
    getoffNodeList() {
      this.$store.dispatch("getOffNodeList").then();
    },
    getAnnualList() {
      this.$store.dispatch("getAnnualList").then();
    },
    getTotalStake() {
      this.$store.dispatch("getTotalStake").then();
    },
    getTotalSupply() {
      this.$store.dispatch("getTotalSupply").then();
    },
    getAnnual($publicKey) {
      let flag = false;
      let annual = "";
      let list;
      let timeFlag = false;
      list = this.annualList.records;
      timeFlag = true;
      for (var i = 0; i < list.length; i++) {
        if ($publicKey == list[i].public_key) {
          if (timeFlag) {
            annual =
              parseFloat(list[i].user_gas_fee_incentive_rate) +
              parseFloat(list[i].user_released_ong_incentive_rate) +
              parseFloat(list[i].user_foundation_bonus_incentive_rate);
            annual = annual.toFixed(2) + "%";
            flag = true;
          } else {
            annual = list[i].annual;
            flag = true;
          }
        }
      }
      if (!flag) {
        annual = "not open";
      }
      return annual;
    },
  },
};
</script>
<style scoped lang="scss">
.calculator-wrapper {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 64px 280px;
  background-color: #f5f6f7;

  @include mobile {
    padding: 20px 20px 40px;
  }
}
.calculator-row {
  max-width: 880px;
  margin: auto;

  @include mobile {
    max-width: 100%;
  }
}
.header-tip {
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: rgba(24, 23, 23, 0.8);
  margin: 30px 0 24px;

  @include mobile {
    text-align: center;
    padding: 0 47px;
    font-weight: 600;
    height: 37px;
    margin-top: 5px;
  }
}
.footer-tip {
  font-family: "Inter";
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 133%;
  letter-spacing: -0.03em;
  color: rgba(24, 23, 23, 0.6);
  text-align: left;

  a {
    color: #48a3ff;
    text-decoration: underline;
  }

  @include mobile {
    text-align: justify;
  }
}
.mgb10 {
  margin-bottom: 10px;
}
::v-deep .el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}
::v-deep .el-tabs__item {
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
}
</style>